export default {
    setCountryCode(state, countryCode) {
        state.countryCode = countryCode;
    }
};
